import { useMemo } from 'react';

export function useExtraBuyQs({
    sellergroup,
    seller,
    extraBuyQs,
}: {
    sellergroup?: any;
    seller?: any;
    extraBuyQs?: any;
}) {
    return useMemo(
        () =>
            [extraBuyQs, sellergroup?.code && `sg=${sellergroup.code}`, seller?.code && `s=${seller.code}`]
                .filter((x) => !!x)
                .join('&')
                .trim() || undefined,
        [sellergroup, seller],
    );
}

export default useExtraBuyQs;
